import { Button } from '@appcharge/shared-ui';
import useLocalization from 'api/useLocalization';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';
import { Download } from 'lucide-react';
import { errorResponse } from 'utils/errorsTextHelper';

import { EToasterStatus, showToast } from '../../../../utils/showToast';

import './style.scss';

const ExportTranslationsCSVSection = () => {
  const { getStaticTranslationsCsvFile, getDynamicTranslationsCsvFile } =
    useLocalization();

  const handleDataExportCSV = async (isDynamic = false) => {
    const response = isDynamic
      ? await getDynamicTranslationsCsvFile.refetch()
      : await getStaticTranslationsCsvFile.refetch();
    if (response.isError) {
      showToast({
        message: errorResponse(response.error as AxiosError),
        status: EToasterStatus.ERROR
      });
      return;
    }
    const { data } = response;
    if (data) {
      const url = window.URL.createObjectURL(
        new Blob([data], { type: 'text/csv' })
      );
      const link = document.createElement('a');
      const formattedDate = dayjs().format('YYYY-MM-DD_HH-mm-ss');
      link.href = url;
      link.setAttribute(
        'download',
        `translations_${isDynamic ? 'dynamic' : 'static'}_${formattedDate}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  };

  return (
    <div className="mt-5">
      <div className="border border-base-sidebarBorder rounded-lg bg-base-background">
        <div className="px-9 pt-9 pb-[25px] flex items-start justify-between gap-6 max-md:flex-col max-md:items-stretch">
          <div className="flex-1">
            <p className="text-[20px] font-semibold text-base-foreground mb-[12px]">
              Download translations
            </p>
            <p className="text-[16px] text-base-mutedForeground max-w-[720px]">
              Download static strings (e.g. labels, buttons) &amp; dynamic strings (e.g. user-specific content) <br /> for translation. Each CSV file includes the original strings and columns for each language.
            </p>
          </div>
          <div className="flex gap-3 shrink-0 max-md:justify-start">
            <Button
              variant="outline"
              onClick={() => handleDataExportCSV(true)}
              leftIcon={<Download className="h-4 w-4" />}
            >
              Dynamic Strings
            </Button>
            <Button
              variant="outline"
              onClick={() => handleDataExportCSV()}
              leftIcon={<Download className="h-4 w-4" />}
            >
              Static Strings
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportTranslationsCSVSection;
